import React from 'react';
import { roundTo3Decimal} from '../../../../../../Utils';

const TotalRow = ({ spends, conversions, eCost }) => {
    const style = { fontSize: '18px', fontWeight: 'bold' };

    return (
        <tr>
            <td colSpan={2}>Total</td>
            <td style={style}>{roundTo3Decimal(spends)}</td>
            <td style={style}>{conversions}</td>
            <td style={style}>{roundTo3Decimal(eCost)}</td>
        </tr>
    );
};

export default TotalRow;



// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/PeriodTable/components/TotalRow/index.js